module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAABHNCSVQICAgIfAhkiAAAAMFJREFUaEPt1cENwyAQRFHTDf1XQzf2zZJvKzQjxvBzJrvwX6S0a9NP2/RdFw/7myxiiIUU4KcYAlG+BmLlVCEHEQuBKF8DsXKqkIOIhUCUr4FYOVXIQcRCIMrXQKycKuTgGWJjjDsk+NQ1eu8v1EeMh0319H8JMX9j7YbzxLT91k47439sbWPtdsS0Pf3TEPM31m5ATNvTPw0xf2PtBsS0Pf3TEPM31m5ATNvTPw0xf2PtBsS0Pf3TEPM31m7YVuwBMOoYNxq+Cv8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/ico_evoucher_minus_off.png
// module id = n1D9
// module chunks = 0